import { LearningPathsUsersApi, type AttendeeTrainingsModel } from "@simbelapp/order-sdk";
import { useUsersStore } from "../users/users.store";
import type { IPaginationApi } from "~/utils/interfaces/table-interfaces";
import type { ILearningPathAttendeeStore } from "~/utils/interfaces/learning-path-interfaces";
import { useSDKApi } from "~/composables/api/useSDKApi";
import { MicroserviceEnum } from "~/utils/enums/common.enums";

export const useLearningPathAttendeeStore = defineStore("learningPathAttendeeStore", {
  state: (): ILearningPathAttendeeStore => ({
    learningPathAttendee: null,
    learningPathAttendeeJourneyFullDatas: null as IPaginationApi<any> | null,
    showAttendee: false,
  }),
  actions: {
    handleLearningPathAttendee(isOpen: boolean) {
      this.showAttendee = isOpen;
    },
    setLearningPathAttendee(learningPathAttendee: any | null) {
      this.learningPathAttendee = learningPathAttendee;
    },
    setLearningPathAttendeeJourneyFullDatas(data: IPaginationApi<AttendeeTrainingsModel> | null) {
      this.learningPathAttendeeJourneyFullDatas = data;
    },
    async loadAttendeeProfile(attendeeId: string, learningPathId: string) {
      try {
        const userStore = useUsersStore();
        const user = await userStore.fetchUser(attendeeId);
        if (user) {
          this.setLearningPathAttendee({
            learningPathId,
            displayValue: {
              value: user.displayValue,
              avatar: user.firstname && user.lastname ? user.firstname.charAt(0) + user.lastname.charAt(0) : "-",
            },
            userId: user.userId,
            attendeeId,
          });
        }
      } catch {
        this.learningPathAttendee = null;
        this.handleLearningPathAttendee(false);

        const route = useRoute();
        const router = useRouter();
        const { attendee_id, ...restQuery } = route.query;
        router.push({
          query: restQuery,
        });
      }
    },
    async fetchLearningPathAttendeeJourneyFullDatas(
      attendeeId: string,
      learningPathId: string,
      paginationOptions?: any,
    ) {
      try {
        const apiInstance = await useSDKApi(MicroserviceEnum.ORDERS, LearningPathsUsersApi);
        const data = await apiInstance.getLearningPathsUsersAttendeeTrainings({
          learningPathId: this.learningPathAttendee?.learningPathId,
          attendeeId: this.learningPathAttendee?.userId,
          ...paginationOptions,
        });
        this.setLearningPathAttendeeJourneyFullDatas({
          data: data.data,
          meta: {
            count: data.meta.count ?? 0,
            totalCount: null,
          },
        });
      } catch {
        this.setLearningPathAttendeeJourneyFullDatas(null);
      }
    },
  },
});
